import React, { memo, useCallback } from 'react';
import { isRuntimeBlockId } from '../../../utils/runTimeBlocks';
import type { WithContextProps } from '../types';
import { useNonReactiveComputeContext } from '../../../hooks/computeContext';
import type { BlockRendererProps } from '../../RegistryProvider/types';

export const withContext = (WrappedComponent: React.ComponentType<BlockRendererProps>) => {
  function WithContextWrapper(props: WithContextProps) {
    const { block, blocksRuntimeState, blockStateId } = props;
    const originalBlockId = block.id;

    const { context } = useNonReactiveComputeContext({
      entityId: originalBlockId,
      // if blockStateId is a runtime block id, we need to pass it as a key otherwise, we send undefined because we just want to
      // subscribe to entityId
      key: isRuntimeBlockId(blockStateId) ? blockStateId : undefined,
      blocksRuntimeState,
    });

    const getGlobalStoreContext = useCallback(() => {
      // if (process.env.NODE_ENV === 'development') {
      //   const node = graphManager.getNode(originalBlockId);
      //
      //   return createContextValidator(context, {
      //     dependsOn: node?.dependsOn,
      //     blockId: originalBlockId,
      //   }) as ComputeContextType;
      // }
      return context;
    }, [context]);

    return (
      <WrappedComponent
        {...props}
        context={context}
        getGlobalStoreContext={getGlobalStoreContext}
      />
    );
  }

  return memo(WithContextWrapper);
};
